import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';


@Injectable({
  providedIn: 'root'
})
export class CursosService {

  constructor(private firestore: AngularFirestore) { }

  public getCurso(id): any {
    return this.firestore.collection('courses').doc(id).get();
  }

  public getCursosCollection(): any {
    return this.firestore.collection('courses').valueChanges({ idField: 'id' });
  }

  public getCursosActivos(): any {
    return this.firestore.collection('courses',
      ref => ref.where('active', '==', true)).valueChanges({ idField: 'id' });
  }

  public establecerPlazaCurso(id, plazas): any {
    return this.firestore.collection('courses').doc(id).update({
      high: plazas,
    });
  }
}
